(function () {
    'use strict';

    angular
        .module('emails')
        .controller('confirmationCancelScheduleController', confirmationCancelScheduleController);

    confirmationCancelScheduleController.$inject = ['$uibModalInstance', 'overviewController','event'];

    function confirmationCancelScheduleController($uibModalInstance, overviewController, event) {
        var vm = this;
        vm.overviewController = overviewController;
        vm.event              = event;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            vm.overviewController.changeStatus(vm.event, 'Canceled');
            $uibModalInstance.close();

        }

        function cancel () {
            $uibModalInstance.close();
        }

    }
})();